import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import classifieds from './classifieds'
import listings from './listings'
import reviews from './reviews'
/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/approvals',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::index
* @see app/Http/Controllers/Admin/ApprovalController.php:31
* @route '/admin/approvals'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\ApprovalController::bulkApprove
* @see app/Http/Controllers/Admin/ApprovalController.php:110
* @route '/admin/approvals/bulk-approve'
*/
export const bulkApprove = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkApprove.url(options),
    method: 'post',
})

bulkApprove.definition = {
    methods: ["post"],
    url: '/admin/approvals/bulk-approve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ApprovalController::bulkApprove
* @see app/Http/Controllers/Admin/ApprovalController.php:110
* @route '/admin/approvals/bulk-approve'
*/
bulkApprove.url = (options?: RouteQueryOptions) => {
    return bulkApprove.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ApprovalController::bulkApprove
* @see app/Http/Controllers/Admin/ApprovalController.php:110
* @route '/admin/approvals/bulk-approve'
*/
bulkApprove.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bulkApprove.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::bulkApprove
* @see app/Http/Controllers/Admin/ApprovalController.php:110
* @route '/admin/approvals/bulk-approve'
*/
const bulkApproveForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkApprove.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ApprovalController::bulkApprove
* @see app/Http/Controllers/Admin/ApprovalController.php:110
* @route '/admin/approvals/bulk-approve'
*/
bulkApproveForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: bulkApprove.url(options),
    method: 'post',
})

bulkApprove.form = bulkApproveForm

const approvals = {
    index: Object.assign(index, index),
    bulkApprove: Object.assign(bulkApprove, bulkApprove),
    classifieds: Object.assign(classifieds, classifieds),
    listings: Object.assign(listings, listings),
    reviews: Object.assign(reviews, reviews),
}

export default approvals